var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Day',{attrs:{"day":_vm.formattedDate}},[_c('div',{attrs:{"slot":"page-content"},slot:"page-content"},[_c('Challenge',{attrs:{"title":_vm.title,"description":_vm.description,"position-link":_vm.positionLink,"position-img":_vm.positionImg}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }